module.exports = __webpack_public_path__ + "kg.5a6fb07cea8d7c825a23.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/kg.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/kg.svg
// module chunks = styles